import { useControl } from 'react-map-gl'
import { AttributionControl } from 'mapbox-gl'

interface AttributionControlEnhanced extends AttributionControl {
  customAttribution: string
}

const CustomAttributionControl = () => {
  useControl(() => {
    const container = new AttributionControl({
      customAttribution:
        'Not for Navigation | © Imray, Laurie, Norie and Wilson Ltd '
    }) as AttributionControlEnhanced

    return container
  })

  return null
}

export default CustomAttributionControl
